import { render, staticRenderFns } from "./SystemCustomNotificationsShowResponse.vue?vue&type=template&id=1c846314&scoped=true"
import script from "./SystemCustomNotificationsShowResponse.vue?vue&type=script&lang=js"
export * from "./SystemCustomNotificationsShowResponse.vue?vue&type=script&lang=js"
import style0 from "./SystemCustomNotificationsShowResponse.vue?vue&type=style&index=0&id=1c846314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c846314",
  null
  
)

export default component.exports